module.exports = __webpack_public_path__ + "static/img/院内ツール発注フォームアイコン.19c5e3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/院内ツール発注フォームアイコン.png
// module id = BP8Y
// module chunks = 0